module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_staging/shared/~/ramda/src/internal/_identity.js
// module id = 61
// module chunks = 0 2 3 4 5 6 7